import { Button, Form, Row } from "antd";
import React, { useEffect } from "react";

import { useTranslation } from "react-i18next";
import DynamicTreeSelect from "../../common/TreeSelect";
import { useDispatch, useSelector } from "react-redux";
import {
  AppDispatch,
  transferSubject,
  transferSubjectRequest,
} from "@src/redux";

interface SubjectTransformProps {
  onCancel: () => void;
  subject: any;
}

const SubjectTransform: React.FC<SubjectTransformProps> = ({
  onCancel,
  subject,
}) => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const dispatch = useDispatch<AppDispatch>();
  const { result: transferSubjectResult, loading: transferSubjectLoading } =
    useSelector(transferSubject);
  const handleTransfer = (values: any) => {
    values.organizationId =
      values.organizationId[values.organizationId?.length - 1];
    dispatch(
      transferSubjectRequest({
        id: subject.id || "",
        data: { organizationId: values.organizationId },
      })
    );
  };

  useEffect(() => {
    if (transferSubjectResult?.status === "success") {
      onCancel();
    }
  }, [transferSubjectResult]);

  return (
    <Form layout="vertical" form={form} onFinish={handleTransfer}>
      {/* <Worker />
      <Workers form={form} /> */}
      <Row gutter={10}>
        <DynamicTreeSelect
          form={form}
          col={24}
          isRequired={true}
          allowClear={false}
          mutationType="edit"
        />
      </Row>
      <div style={{ display: "flex", justifyContent: "flex-end" }}>
        <Button style={{ marginRight: "10px" }} onClick={onCancel} danger>
          {t("close")}
        </Button>
        <Button
          htmlType="submit"
          loading={transferSubjectLoading}
          type="primary"
        >
          {t("transfer")}
        </Button>
      </div>
    </Form>
  );
};

export default SubjectTransform;
